import { TranslateFunction } from '../../internationalisation/types/InternationalisationContextValue';

export const notBeNull = <TValue>(translate: TranslateFunction) => ({
  predicate: (value: TValue) => value != null,
  message: translate('validation.requiredField'),
});
